import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const SliderWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 40px 24px;

  .slick-dots {
    bottom: -28px;

    li {
      width: 10px;

      button::before {
        font-size: 12px;
      }

      button:focus:before {
        opacity: 0.25;
      }
    }

    .slick-active {
      button:focus:before {
        opacity: 0.75;
      }
    }
  }

  @media screen and (min-width: ${layout.subLg}) {
    padding: 80px 24px;
  }
`;

// display: flex !important is necessary to overwrite
// the inline display: block that's applied by the react-slick script
export const IndividualSlideWrapper = styled.div`
  width: 100%;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: ${layout.subMd}) {
    flex-direction: row;
  }
`;

export const ImageInfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (min-width: ${layout.subMd}) {
    width: 28%;
  }

  h2, p {
    text-align: center;
  }

  h2 {
    margin-bottom: 25px;
  }
`;

// display: flex !important is necessary to overwrite
// the inline display: block that's applied by the react-slick script
export const DesktopImage = styled.div`
  display: none !important;
  width: 80%;
  max-width: 1000px;

  @media screen and (min-width: ${layout.subMd}) {
    display: block !important;
    width: 72%;
  }
`;

export const MobileImage = styled.div`
  max-width: 275px;
  width: 100%;

  @media screen and (min-width: ${layout.subMd}) {
    display: none !important;
  }
`;

export const LogoImage = styled.div`
  display: none !important;
  max-width: 100%;
  margin-bottom: 25px;
  max-height: 44px;

  @media screen and (min-width: ${layout.subMd}) {
    display: block !important;
  }
`;
